<div class="is-flex is-spaced-between">
    <p class="is-level-2 title is-marginless mb-1">{{ dataEnvelope.replace('Go', '&nbsp;Go') }}</p>
    <span class="icon is-stretched is-medium is-pulled-right">
        <i [ngClass]="'tri-' + connectionSpeed" aria-hidden="true"></i>
    </span>
</div>
<p class="text is-level-3 description-block" [innerHTML]="catchyDescription"></p>
@if (atLeastOneBlockablePlan) {
    <div class="locked-plans-form">
        <div class="field is-marginless force-click">
            @if (canBeLockedPlan) {
                <div class="checkbox mb-2">
                    <input type="checkbox" id="locked-{{ gencode }}" [checked]="isLocked" (change)="lockedToggle()" />
                    <label class="checkbox-label" for="locked-{{ gencode }}">Forfait bloqué</label>
                </div>
            }
        </div>
    </div>
}
